$(document).on('click','#option-1.is-sub', function() {
  $( '.select-one' ).trigger('click');
});

$('.option-1').click(function(){
    $('.option-2').removeClass("active");
  $('.option-3').removeClass("active");
     	$('.option-1').addClass("active");
  $('.subbox.three').hide();
  $('.subbox.six').hide();
  $('.subbox.one').show();
  $( "#bonus60" ).prop( "disabled", true );
  $( "#bonus180" ).prop( "disabled", true );
        $('#rc_autodeliver_options select').val('30').change();
    $('#SingleOptionSelector-0').val('30 Day').change();
});




$(document).on('click','#option-2.is-sub', function() {
  $( '.select-two' ).trigger('click');
});

$('.option-2').click(function(){
    $('.option-1').removeClass("active");
  $('.option-3').removeClass("active");
     	$('.option-2').addClass("active");
  $('.subbox.one').hide();
  $('.subbox.six').hide();
  $('.subbox.three').show();
   $( "#bonus60" ).prop( "disabled", false );
  $( "#bonus180" ).prop( "disabled", true );
        $('#rc_autodeliver_options select').val('90').change();
    $('#SingleOptionSelector-0').val('90 Day').change();
});




$(document).on('click','#option-3.is-sub', function() {
  $( '.select-three' ).trigger('click');
});


$('.option-3').click(function(){
    $('.option-1').removeClass("active");
  $('.option-2').removeClass("active");
     	$('.option-3').addClass("active");
  $('.subbox.one').hide();
  $('.subbox.three').hide();
  $('.subbox.six').show();
    $( "#bonus60" ).prop( "disabled", true );
  $( "#bonus180" ).prop( "disabled", false );
        $('#rc_autodeliver_options select').val('180').change();
    $('#SingleOptionSelector-0').val('180 Day').change();
   	$('#bonustitle').val('{{ oneeightyBonusTitleBonusTitle }}').change();

});





$(document).on('click','.subbox.one.active', function() {
  
  $('.optionbox').removeClass("is-sub"); 
  
    $('.subbox.one').removeClass("active");  
      $('.subbox').removeClass("active"); 
        $('.subbox').addClass("offline"); 
  $('#__product-subscription-info').hide();
     $('#__product-subscription-info').hide();
    $(".rc_label__onetime").trigger('click');
  
   $(".select-onetime").trigger('click');
  
  
  $('.__inno_product_purchase_btn').text("ADD TO CART");

});


$(document).on('click','.subbox.one.offline', function() {
  
   $('.optionbox').addClass("is-sub"); 
    $( '.select-one' ).trigger('click');
    $('.__inno_product_purchase_btn').text("Subscribe Now");
   $('.subbox').addClass("active");
        $('.subbox').removeClass("offline");
   $('#__product-subscription-info').show();
      $(".rc_label__autodeliver").trigger('click');
        $('#rc_autodeliver_options select').val('30').change();
    $('#SingleOptionSelector-0').val('30 Day').change();
  
   	
});



$(document).on('click','.subbox.three.active', function() {
  
   $('.optionbox').removeClass("is-sub"); 
  
    $('.subbox.one').removeClass("active");  
      $('.subbox').removeClass("active"); 
        $('.subbox').addClass("offline"); 
  $('#__product-subscription-info').hide();
     $('#__product-subscription-info').hide();
    $(".rc_label__onetime").trigger('click');
  
     $(".select-onetime").trigger('click');
  
  $('.__inno_product_purchase_btn').text("ADD TO CART");

});


$(document).on('click','.subbox.three.offline', function() {
  
     $('.optionbox').addClass("is-sub"); 
    $( '.select-two' ).trigger('click');
    $('.__inno_product_purchase_btn').text("Subscribe Now");
   $('.subbox').addClass("active");
        $('.subbox').removeClass("offline");
   $('#__product-subscription-info').show();
      $(".rc_label__autodeliver").trigger('click');
        $('#rc_autodeliver_options select').val('90').change();
    $('#SingleOptionSelector-0').val('90 Day').change();
  
   	
});
 




$(document).on('click','.subbox.six.active', function() {
  
   $('.optionbox').removeClass("is-sub"); 
  
    $('.subbox.six').removeClass("active");  
      $('.subbox').removeClass("active"); 
        $('.subbox').addClass("offline"); 
  $('#__product-subscription-info').hide();
     $('#__product-subscription-info').hide();
    $(".rc_label__onetime").trigger('click');
  
     $(".select-onetime").trigger('click');
  
  $('.__inno_product_purchase_btn').text("ADD TO CART");

});


$(document).on('click','.subbox.six.offline', function() {
  
     $('.optionbox').addClass("is-sub"); 
    $( '.select-three' ).trigger('click');
    $('.__inno_product_purchase_btn').text("Subscribe Now");
   $('.subbox').addClass("active");
        $('.subbox').removeClass("offline");
   $('#__product-subscription-info').show();
      $(".rc_label__autodeliver").trigger('click');
        $('#rc_autodeliver_options select').val('180').change();
    $('#SingleOptionSelector-0').val('180 Day').change();
   
   	
});
 
$( document ).ready(function() {
   $( '.select-two' ).trigger('click');
$('#SingleOptionSelector-0').val('90 Day').change();
});





